import React from 'react';
import styled from '@benzinga/themetron';

const WatchlistSidebarWidget = React.lazy(() =>
  import('@benzinga/widgets').then(module => {
    return { default: module.WatchlistSidebarWidget };
  }),
);

export interface WatchlistSidebarWidgetBlockProps {
  attrs: {
    data: {
      hide_text?: boolean;
    };
  };
}

export const WatchlistSidebarWidgetBlock: React.FC<WatchlistSidebarWidgetBlockProps> = ({ attrs }) => {
  const hideText = attrs?.data?.hide_text;
  return (
    <Container className="watchlist-sidebar-widget-block">
      <WatchlistSidebarWidget hideText={hideText} />
    </Container>
  );
};

export const Container = styled.div`
  &.watchlist-sidebar-widget-block {
    margin: 1rem 0;
  }
`;
